import type { ListPageConfig } from '@/lib/filters/types'

export const STATUS_FILTER_OPTIONS = [
  { value: 'DRAFT', label: 'Draft' },
  { value: 'PENDING_REVIEW', label: 'Pending Review' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'CANCELLED', label: 'Cancelled' },
]

/**
 * Base config, consumed by `useListPageState` for decode/encode. `entity.options` is empty here —
 * enriched with fetched client-side options for `FilterBar`'s own `config` prop only (see
 * `DocumentsPage.tsx`'s `filterConfigWithEntities`); decoding a `select` field never depends on
 * its `options` list, only on the raw URL string.
 */
export const documentsFilterConfig: ListPageConfig = {
  routeId: '/documents/',
  pageId: 'documents',
  fields: [
    { id: 'status', label: 'Status', type: 'select', options: STATUS_FILTER_OPTIONS, allLabel: 'All statuses' },
    { id: 'entity', label: 'Entity', type: 'select', options: [], allLabel: 'All entities' },
    // `placeholder` IS this field's accessible name — FilterBar routes `type: 'search'` fields out
    // of the rail into its own toolbar DebouncedSearchField, which reads only
    // `value`/`onChange`/`placeholder` (never `ariaLabel`).
    { id: 'createdBy', label: 'Created by', type: 'search', placeholder: 'Filter by creator…' },
  ],
}
